import React from "react";
import "./Services.css";
import pic from "../../assets/Group 21.png";
const Services = () => (
  <div className='services__container section__padding' id='services'>
        <img src={pic}/>
  </div>
);

export default Services;
